module.exports = __webpack_public_path__ + "static/media/call_center.22f103ac.svg";